$(document).ready(function () {
   $('.itg_sub_menu_hover').hover(
     function () {
       var hover_img = $(this).attr('collection-img');
       var product_count = $(this).attr('product-count');
       $('.itg_menu_clctn li.itg_dropdown-submenu_img').addClass('hover_img_hide');
       $('.itg_menu_cltn_img').addClass('active');
       $('.itg_menu_cltn_img img').attr('src',hover_img);
       $('.menu_product_count').replaceWith("<h4 class='menu_product_count'>"+product_count+" Products"+"</h4>")
     }, 
     function () {
       $('.itg_menu_clctn li.itg_dropdown-submenu_img').removeClass('hover_img_hide');
       $('.itg_menu_cltn_img').removeClass('active');
     }
   );
});
$('.itg_collection-grid').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: true,
  prevArrow: "<button class='slide-arrow prev-arrow'><svg width='800px' height='800px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M15 6L9 12L15 18' stroke='#000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  nextArrow: "<button class='slide-arrow next-arrow'><svg width='800px' height='800px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M9 6L15 12L9 18' stroke='#000000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows:false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        dots: true
      }
    }
  ]
});

var variant_index = $('.shopify-product-form').find('.swatch').length;
if(variant_index > 1){
  $(document).on('change','.swatch:first-child .swatch-element input',function() {
    $('.swatch-items-wrapper .swatch-element').removeClass("soldout");
    var input_val = $(this).val();
    $('.product-single__variants.original-select option[option1="'+input_val+'"]').each(function () {
      var option1 = $(this).attr("option1");
      if(input_val == option1){
        var option2 = $(this).attr("option2");
        $('.swatch-items-wrapper').find('[data-value="'+option2+'"]').addClass("soldout");
      }
    });
  });

  $('.swatch-items-wrapper .swatch-element').removeClass("soldout");
  var this_ = $('.swatch:first-child .swatch-element input:checked')
  var input_val = this_.val();
  $('.product-single__variants.original-select option[option1="'+input_val+'"]').each(function () {
    var option1 = $(this).attr("option1");
    if(input_val == option1){
      var option2 = $(this).attr("option2");
      $('.swatch-items-wrapper').find('[data-value="'+option2+'"]').addClass("soldout");
    }
  });
}















